import pulse, { type TrackerData } from '@finn-no/pulse-sdk';
import { getCategoryForAdViewType } from '@m10s/mobility-mapping-utils';
import { useCallback } from 'react';
import { getLookupConfig } from '../utils/getHuckConfig.js';

const trackPageView = (model: string) => {
  pulse.trackPageView({
    name: 'Ad insertion - mobility',
    object: {
      stepName: 'Regnumber lookup',
      action: 'Create ClassifiedAd',
      type: 'Form',
      name: document.title,
      items: [
        {
          type: 'ClassifiedAd',
          name: 'n/a',
          id: 'n/a',
          category: getCategoryForAdViewType(model),
        },
      ],
    },
    vertical: {
      name: 'mobility',
    },
  });
};

type TrackerDataWithoutObjectIdAndType = Omit<TrackerData, 'object'> & {
  object: {
    elementType: string;
  };
};

const trackClick = (model: string, data: TrackerDataWithoutObjectIdAndType) => {
  pulse.trackEvent({
    type: 'Click',
    intent: data.intent ?? 'Open',
    name: data.name,
    object: {
      id: undefined as unknown as string,
      type: 'UIElement',
      elementType: data.object.elementType,
      items: [
        {
          type: 'ClassifiedAd',
          name: 'n/a',
          id: 'n/a',
          category: getCategoryForAdViewType(model),
        },
      ],
    },
    target: data.target,
    vertical: { name: 'mobility' },
  });
};

/**
 * Hook for tracking analytics during the vehicle lookup phase (before an item exists).
 * Different from the form app's usePulse which requires an ItemResponse.
 */
export const useLookupPulse = (model: string) => {
  const config = getLookupConfig();
  const resolvedModel = model || config.model;

  const trackPageViewCallback = useCallback(() => {
    trackPageView(resolvedModel);
  }, [resolvedModel]);

  const trackClickCallback = useCallback(
    (data: TrackerDataWithoutObjectIdAndType) => {
      trackClick(resolvedModel, data);
    },
    [resolvedModel],
  );

  return {
    trackPageView: trackPageViewCallback,
    trackClick: trackClickCallback,
  };
};
